import { render, staticRenderFns } from "./RolesManager.vue?vue&type=template&id=16bed549&"
import script from "./RolesManager.vue?vue&type=script&lang=js&"
export * from "./RolesManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports